import _ from '@lodash';
import { Controller, FormProvider, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import PiAfEventReaderService from 'app/admin/piAfEventReader/service/PiAfEventReaderService';
import EditFormSelectField from 'modules/ui/editform/fields/EditFormSelectField';
import { useWhatIf } from './WhatIfProvider';

function WhatIfPiAfEventReaderSelect() {
	const { t } = useTranslation('whatIf');
	const { data, setData } = useWhatIf();
	const methods = useForm({
		defaultValues: {
			piAfEventReader: _.get(data, 'properties.piAfEventReader', null)
		},
		mode: 'onChange'
	});

	const handleChange = value => {
		if (!_.isUndefined(value)) {
			setData({
				...data,
				properties: {
					..._.get(data, 'properties', {}),
					...methods.getValues()
				}
			});
		}
	};

	return (
		<FormProvider {...methods}>
			<div className="flex flex-row">
				<Controller
					control={methods.control}
					name="piAfEventReader"
					render={({ field, fieldState }) => (
						<EditFormSelectField
							field={field}
							fieldState={fieldState}
							config={{ topic: 'whatIf' }}
							fieldConfig={{
								key: 'piAfEventReader',
								text: t('piAfEventReader'),
								onChange: handleChange,
								items: () => PiAfEventReaderService.getListSelection()
							}}
						/>
					)}
				/>
			</div>
		</FormProvider>
	);
}

export default WhatIfPiAfEventReaderSelect;
